export const CHECKOUT_URL =
  'https://entrenador-baloncesto.impultienda.ar/checkout?utm_source=magic_patterns&utm_medium=organic&utm_campaign=landing_principal';
